<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="修改SPU"
      width="600px"
      :innerScroll="false"
      :qLoading="confirmLoading"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-form :model="form" size="small" :inline="true" :rules="rules" ref="ruleForm" label-width="110px" v-loading="loading">
        <el-form-item label="SPU名称" prop="spuName">
          <!-- <el-input v-model.trim="form.spuName" /> -->
          <el-input type="textarea" autosize  v-model.trim="form.spuName" style="width:150px" />
        </el-form-item>
        <el-form-item label="类别" prop="productTypeCode">
          <el-select v-model="form.productTypeCode">
              <el-option v-for="(item, index) in productTypeCodeList" :key="index"
                :label="item.typeName" :value="item.typeCode" ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="预计上线时间" prop="expOnelineTime">
          <el-date-picker
            v-model="form.expOnelineTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="SPU品类：" prop="spuCategory">
          <el-input v-model.trim="form.spuCategory" />
        </el-form-item>
        <el-form-item label="所属板块：" prop="plate">
          <el-select v-model="form.plate">
            <el-option :label="item" :value="item" v-for=" (item,index) in ['板式', '软体']" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺：" v-if="form.productTypeCode  == 6">
          <el-select v-model="form.storeCodes" multiple collapse-tags filterable placeholder="请选择">
            <el-option v-for="item in storeList" :key="item.storeCode" :label="item.storeName" :value="item.storeCode"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片" prop="e" style="width: 553px;">
          <el-upload
            class="upload-demo"
            action=""
            multiple
            :limit="10"
            :on-remove="handleRemove"
            :on-preview="handlePreview"
            :before-upload="beforeAvatarUpload"
            :on-exceed="handleExceed"
            :http-request="handleHttprequest"
            :file-list="form.picList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip" style="line-height: 16px; color: #999;">
              说明：最多可上传5张图片，且每张图片<br/>不可大于10M
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注：" prop="productRemark">
          <el-input v-model="form.productRemark" type="textarea" :rows="2" placeholder="请输入内容" style="width: 420px;" />
        </el-form-item>
      </el-form>

      <img-preview v-model="imgPreviewVisible" :data="imgData" :detailType="0" v-if="imgPreviewVisible"></img-preview>
    </q-dialog>
  </div>
</template>

<script>
import {assignValue} from '@/utils'
import imgPreview from '@/views/components/imgPreview.vue'
import imgUploadMixin from '../newproduct-add/img-upload.mixin'
import axios from "@/utils/axiosInstance";
const ONE_DAY_MILLSECONDS = 24 * 60 * 60 * 1000;
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  components: {
    imgPreview
  },
  props: ['visible', 'spuCode'],
  mixins: [imgUploadMixin],
  data() {
    return {
      dialogVisible: false,
      // 业务
      locationOpt: [],
      styleList: [],
      form: {
        dataId: '',
        spuCode: '',
        spuName: '',
        productTypeCode: '',
        expOnelineTime: '',
        spuCategory: '',
        productRemark: '',
        picList: [],
        plate: "",
        storeCodes: []
      },
      rules: {
        spuName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        productTypeCode: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        expOnelineTime: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        spuCategory: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        plate: [
          { required: true, message: '不能为空', trigger: 'change' }
        ]
      },
      productTypeCodeList: [],
      storeList: [],
      loading: false,
      imgPreviewVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now() - ONE_DAY_MILLSECONDS);
        }
      },
      confirmLoading: false
    }
  },
  computed: {
    imgData() {
      return this.form.picList.map(item => ({url: item.path}));
    }
  },
  created() {
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.confirmLoading = true;
      this.$refs['ruleForm'].validate(valid=>{
        if(!valid) {
          this.confirmLoading = false;
          return;
        };
        this.$q.newProduct.addSpu({data: this.form})
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '成功',
                message: '修改SPU成功',
              });
              this.updateVal();
              this.$emit('success');
            }
          })
          .finally(_=>{
            this.confirmLoading = false;
          })
      })
    },
    getSpuInfo() {
      const params = {
        data: {
          pageNum: 1,
          pageSize: 1,
          filterData: {
            spuCode: this.spuCode
          }
        }
      };
      this.loading = true;
      return this.$q.newProduct.listPage(params)
        .then(({data}) => {
          const spuInfo = data && data.records && data.records[0] || {};
          assignValue(this.form, spuInfo);
        })
        .catch(console.log)
        .finally(() => {
            this.loading = false;
          });;
    },
    getNewProductType() {
      this.$q.newProduct.getNewProductType()
        .then(res => {
          this.productTypeCodeList = res.data || [];
        })
        .catch(console.log);
    },
    //获取店铺
    getStoreList() {
      let currencyForm = {
        pageSize: 999999,
        pageNum: 1,
        hasCount: "N",
        reportCode: 'storeInfoList'
      }
      axios.post(`/ec-pc-api/custom/reports/data/storeInfoList`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list;
        }
      });
    },
    async init() {
      this.dialogVisible = this.visible;
      await this.getNewProductType();
      this.getSpuInfo();
      this.getStoreList()
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-upload-list
    // position absolute
    // left 220px
    // top -5px
    float right
    margin-left 220px
    margin-top -75px
</style>